import { Intersect } from '@/directives/intersect'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('intersect', Intersect)
})
